/**
* 功能: 解说视频的录入 (相关开发摘要可以查看/report/backend/doc/01 upload.md)
*/

<template lang="pug">
  el-dialog.commentary-dialog(:title="titleText" :visible.sync="dialogVisible" width="70%" @close="dialogVisible = false" :close-on-click-modal="false" :before-close="closeDialog")
    el-form(:model="formData" ref="form" label-width="80px" :rules="rules")
      el-row
        el-col(:span="11")
          el-form-item(label="发布日期" prop="pubDate")
            el-date-picker(v-model="formData.pubDate" type="datetime" placeholder="选择发布日期" align="right" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-col(:span="11")
          el-form-item(label="类型")
            el-select(placeholder="请选择解说类型" v-model="formData.type" :size="GLOBAL.SIZE_OF_INPUTBOX")
              el-option(v-for="item in VIDEO_TYPE" :key="item.value" :label="item.label" :value="item.value")
      el-row
        el-col(:span="11")
          el-form-item(label="标题" prop="title")
            el-input(v-model="formData.title" autocomplete="off" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-col(:span="11")
          el-form-item(label="作者")
            el-input(v-model="formData.author" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="11")
          el-form-item(label="标签")
            input-tag(@getData="getLabels" :tagData="formData.labels")
        //- el-col(:span="11")
        //-   el-form-item(label="行业")
        //-     frost-industry(v-model="formData.industryId" :size="GLOBAL.SIZE_OF_INPUTBOX" v-bind:name="formData.industry" v-on:change="formData.industry = $event")
        //- el-col(:span="11")
        //-   el-form-item(label="视频地址")
        //-     el-input(v-model="formData.url" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-col(:span="11")
          el-form-item(label="厂牌")
            brandSelect(v-model="formData.brand" :brandName="formData.brandName" @brandName="getbrandName")
        el-col(:span="11")
          el-form-item(label="关联报告")
            el-autocomplete(style="width:100%;"
            v-model="formData.reportName"
            :fetch-suggestions="searchReport"
            clearable
            :size="GLOBAL.SIZE_OF_INPUTBOX"
            @clear="handelRemoveByKey('report')"
            @select="handelSelectReport"
            @input="handleChange('report')")
      el-row
        el-col(:span="11")
          el-form-item(label="视频vid")
            div.vid-Input
              el-input(v-model="formData.vid" :size="GLOBAL.SIZE_OF_INPUTBOX" readonly)
        el-col(:span="11")
          el-form-item(label="视频时长" prop="duration")
            div.vid-Input
              el-input(v-model="formData.duration" :size="GLOBAL.SIZE_OF_INPUTBOX" readonly)
      el-row
        el-col(:span="5")
          el-row
            el-form-item(label="视频上传")
              div(v-if="uploadStatus !== 'ing' && !formData.filename" style="width: 40px; height: 40px; cursor: pointer")
                input.upload-input(type="file" @change="handleVideo" name="file" accept = "video/mp4,video/mov")
                i.el-icon-plus.avatar-uploader-icon.avatar-uploader
              el-progress.progress-style(:text-inside="true" :stroke-width="26" :percentage="progress" v-if="uploadStatus==='ing'")
              div(v-if="formData.filename")
                span {{formData.filename}}
                i.el-icon-delete.file-dele-icon(@click="deleteVideo" style="margin-left:10px; cursor: pointer" v-if="!readOnly")
          el-row
            el-form-item(label="头图上传")
              div(v-if='!readOnly')
                el-upload(
                  :action='GLOBAL.uploadHost+"video/header_upload"'
                  :headers="headers" name="image"
                  accept="image/jpeg,image/png" :show-file-list="false"
                  :on-success="handleUploaded" :before-upload="beforeAvatarUpload")
                  img.avatar(v-if="formData.image" :src="formData.image" style="max-height:100px;max-width: 100%;")
                  i.el-icon-plus.avatar-uploader-icon(v-else)
                el-button(v-if="formData.image" icon="el-icon-delete" circle @click="handelRemoveByKey('image')")
              div(v-else)
                img.avatar(v-if="formData.image" :src="formData.image" style="max-height:100px;max-width: 100%;")
          el-row
            el-form-item(label="是否限免")
              el-checkbox(v-model="formData.free")
        el-col(:span="17")
          el-form-item(label="描述")
            el-input(v-model="formData.description" :size="GLOBAL.SIZE_OF_INPUTBOX" type="textarea" rows="8")
    div.dialog-footer(slot="footer")
      el-button(@click="closeDialog" :size="GLOBAL.SIZE_OF_INPUTBOX" v-if="formData.filename") 取 消
      el-button(type="primary" @click="handleSave" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="readOnly") 确 定

</template>
<script>
import brandSelect from '@/components/brandSelect'
import passport from '@/javascripts/passport'
import InputTag from '@/components/InputTag'
import FrostIndustry from '@/components/industry'
import api from '@/apis/brief'
import { getUploadAddress, refreshUploadAddress, deleteVideo } from '@/apis/video'
import Enum from '@/apis/enum'

import { hhmmssTotime, timeTohhmmss } from '@/javascripts/time'
export default {
  name: 'CommentaryDialog',
  components: { InputTag, FrostIndustry, brandSelect },

  data () {
    const checkDuration = (rule, value, callback) => {
      const REG = /^([01][0-9]|[2][0-3]):[0-5][0-9]:[0-5][0-9]$/
      const REG_ = /^[0-5][0-9]:[0-5][0-9]$/
      if (value && !(REG.test(value) || REG_.test(value))) {
        callback(new Error('请输入00:00或00:00:00格式的数据'))
      } else {
        callback()
      }
    }

    return {
      VIDEO_TYPE: Enum.VIDEO_TYPE,

      dialogVisible: false,
      searchTimeout: null,
      headers: passport.headers(),
      rules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' },
        duration: { required: true, trigger: 'blur', validator: checkDuration },
        pubDate: { required: true, message: '请选择发布日期', trigger: 'blur' }
      },
      formData: {
        industry: [],
        industryId: [],
        free: true,
        type: 1
      },
      uploader: '',
      progress: 0,
      uploadStatus: '',
      tempForm: ''
    }
  },

  computed: {
    titleText () {
      return this.formData._id ? '更新解说' : '新增解说'
    },

    readOnly () {
      return this.formData.status > 0
    }
  },

  methods: {
    // 关闭dialog
    closeDialog () {
      // 手动取消显示
      // this.formData.brandName = ''
      if (!this.formData.filename && this.formData._id) {
        return this.$message({ type: 'warning', message: '视频文件必须上传' })
      }
      this.tempForm.brandName = ''
      this.formData.brandName = '' // form对象会多出一个brandName字段
      if (JSON.stringify(this.tempForm) !== JSON.stringify(this.formData) && !this.readOnly) {
        this.$confirm('检测到您还有内容未保存，是否保存?', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        }).then(() => {
          this.handleSave()
        }).catch(() => { // 取消保存
          if (this.formData.vid !== this.tempForm.vid) { // 视频发生变化
            deleteVideo({ videoId: this.formData.vid, id: this.formData._id }).then(res => {
              if (res && res.errCode === 0) {
                this.progress = 0
                this.uploadStatus = ''
                this.uploader = ''
                this.formData.filename = ''
                this.formData.duration = '00:00:00'
                this.formData.vid = ''
                this.formData.free = true
                this.$message({ type: 'warning', message: '视频文件必须上传' })
              }
            })
            if (!this.formData._id) this.$emit('close')
          } else {
            this.formData = this.tempForm
            this.$emit('close')
          }
        })
      } else {
        this.$emit('close')
      }
    },
    // 显示dialog
    show (data) {
      if (!data._id) {
        data.free = true
        data.type = 1
      }
      this.dialogVisible = true
      this.formData = data
      const duration = (data && data.duration) || null
      this.formData.duration = timeTohhmmss(duration)
      this.tempForm = JSON.parse(JSON.stringify(this.formData))
      this.progress = 0
      this.uploadStatus = ''
    },
    // 执行保存操作
    handleSave () {
      const { reportName, report, brandName, brand, filename, image } = this.formData
      if (reportName && !report) {
        return this.$message({ type: 'warning', message: '请从下拉列表中选择关联报告' })
      }
      if (brandName && !brand) {
        return this.$message({ type: 'warning', message: '请从下拉列表中选择厂牌' })
      }
      if (!filename) return this.$message({ type: 'warning', message: '视频文件必须上传' })
      if (!image) return this.$message({ type: 'warning', message: '头图必须上传' })
      this.formData.report = report || null
      this.formData.brand = brand || null
      this.$refs.form.validate(valid => {
        if (valid) {
          const result = JSON.parse(JSON.stringify(this.formData))
          result.duration = hhmmssTotime(result.duration)
          if (!this.formData._id) {
            this.$emit('create', result)
          } else {
            this.$emit('update', result)
          }
        }
      })
    },
    // 根据关键词搜索关联报告
    searchReport (queryString, callbackf) {
      clearTimeout(this.searchTimeout)
      if (!queryString || queryString.length < 2) {
        callbackf([])
      } else {
        this.searchTimeout = setTimeout(() => {
          api.searchBriefTitle({ text: queryString }).then(r => {
            const result = r.data.map(i => ({ value: i.title, id: i._id }))
            callbackf(result)
          }).catch(err => {
            this.$message({ message: err, type: 'error' })
          })
        }, 500)
      }
    },
    // 删除关联数据
    handleChange (key) {
      delete this.formData[key]
    },
    // 选择下拉菜单报告
    handelSelectReport (data) {
      this.formData.report = data.id
    },
    // 根据key移除form表单里面的值
    handelRemoveByKey (key, value = '') {
      this.formData[key] = value
      this.$forceUpdate()
    },
    // 上传头图
    handleUploaded (data) {
      if (data.errCode === 0) {
        this.formData.image = data.data.url
        this.$forceUpdate()
      } else {
        this.$emit({ type: 'error', message: '上传图片失败！' })
      }
    },
    // 视频上传
    handleVideo (event) {
      const file = event.target.files[0]
      if (!file) {
        return this.$message.warning('请先选择需要上传的文件!')
      }
      // this.formData.filename = file.name
      var url = URL.createObjectURL(file)// 获取录音时长
      var audioElement = new Audio(url)
      const that = this
      audioElement.addEventListener('loadedmetadata', function (_event) {
        that.formData.duration = timeTohhmmss(audioElement.duration)
      })
      if (this.uploader) {
        this.uploader.stopUpload()
      }
      this.uploader = this.createUploader()
      this.uploader.addFile(file, null, null, null, '{"Vod":{}}')
      this.uploader.startUpload()
    },
    // 调用ali vod上传视频解说的方法
    createUploader () {
      const self = this
      // eslint-disable-next-line
      var uploader = new AliyunUpload.Vod({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: self.GLOBAL.region || 'cn-shanghai',
        userId: self.GLOBAL.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log('添加文件成功, 等待上传...')
          console.log('addFileSuccess: ' + uploadInfo.file.name)
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          if (!uploadInfo.videoId) {
            getUploadAddress({ fileName: uploadInfo.file.name }).then(res => {
              const uploadAuth = res.data.UploadAuth
              const uploadAddress = res.data.UploadAddress
              const videoId = res.data.VideoId
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
              self.formData.vid = uploadInfo.videoId
              self.$set(self.formData, 'vid', uploadInfo.videoId)
              self.uploadStatus = 'ing'
              console.log('文件开始上传...', uploadInfo.videoId)
            })
            console.log('onUploadStarted:' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object)
          } else {
            refreshUploadAddress({ videoId: uploadInfo.videoId }).then(res => {
              const uploadAuth = res.data.UploadAuth
              const uploadAddress = res.data.UploadAddress
              const videoId = res.data.VideoId
              self.formData.vid = res.data.VideoId
              self.$set(self.formData, 'vid', res.data.VideoId)
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
            })
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.formData.filename = uploadInfo.file.name
          console.log('onUploadSucceed: ' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object)
          self.uploadStatus = 'success'
          self.$message.success('文件上传成功!')
          console.log('文件上传成功!')
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log('onUploadFailed: file:' + uploadInfo.file.name + ',code:' + code + ', message:' + message)
          self.$message.error(message, '文件上传失败!')
          console.log('文件上传失败!')
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          console.log('Canceled file: ' + uploadInfo.file.name + ', code: ' + code + ', message:' + message)
          console.log('文件已暂停上传')
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(progress * 100) + '%')
          const progressPercent = Math.ceil(progress * 100)
          self.progress = progressPercent
          self.uploadStatus = 'ing'
          console.log('文件上传中...', progressPercent)
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          console.log('文件超时,重新上传中...')
          refreshUploadAddress({ videoId: uploadInfo.videoId }).then(res => {
            const uploadAuth = res.data.UploadAuth
            uploader.resumeUploadWithAuth(uploadAuth)
          })
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log('文件上传完毕')
        }
      })
      return uploader
    },
    // 删除视频
    deleteVideo () {
      this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        deleteVideo({ videoId: this.formData.vid, id: this.formData._id }).then(res => {
          if (res && res.errCode === 0) {
            this.$message.success('删除成功！')
            this.uploader = ''
            this.formData.filename = ''
            this.formData.duration = '00:00:00'
            this.progress = 0
            this.uploadStatus = ''
            this.formData.vid = ''
            this.$forceUpdate()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    },
    // 获取标签的值
    getLabels (data) {
      this.formData.labels = data
    },
    // 获取厂牌的值
    getbrandName (brandName) {
      this.formData.brandName = brandName
    },
    // 上传校验
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      this.loading = true
      if (!isJPG) this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      if (!isLt2M) this.$message.error('上传头像图片大小不能超过 1MB!')
      this.loading = false
      return isJPG && isLt2M
    },
    handleUploadedVideo (data) {
      this.formData.vid = data.data.vid
      this.$forceUpdate()
    }
  }
}
</script>

<style>
.vid-Input .el-input__inner {
  cursor: not-allowed;
  background-color: #F5F7FA;
  color: #C0C4CC;
  border-color: #E4E7ED;
}

.commentary-dialog .el-upload-dragger {
  width: 200px;
}

.commentary-dialog .el-form-item {
  margin-bottom: 20px;
}

.commentary-dialog .avatar-uploader {
  width: 40px;
  height: 40px;
  position: absolute;
}

.commentary-dialog .avatar-uploader::before {
  position: absolute;
  top: 12px;
}

.commentary-dialog .upload-input {
  position: absolute;
  z-index: 1;
  opacity: 0;
  height: 40px;
  width: 40px;
  font-size: 0;
  cursor: pointer;
}

.commentary-dialog .progress-style {
  position: relative;
  top: 5px;
}
</style>